import FacebookIcon from '@mui/icons-material/Facebook';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import RedditIcon from '@mui/icons-material/Reddit';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import YouTubeIcon from '@mui/icons-material/YouTube';

import { EncuestaFieldsComponent } from '@/erp/operaciones/preagendamiento/shared/components';
import { gridSize, gridSizeMdLg6 } from '@/shared';
import { SampleCheckboxNoForm, TabTextLabel } from '@/shared/components/ui';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import { Contrato, UsosPreagendaType } from '@/shared/interfaces';

export type ClienteFibraSurveyFormTabProps = {
  contract: Contrato;
};

const ClienteFibraSurveyFormTab: React.FC<ClienteFibraSurveyFormTabProps> = ({
  contract,
}) => {
  const usos: UsosPreagendaType | null =
    contract?.preagendamiento_data?.usos || null;
  const tipoUsoTrueQuantity = Object.values(usos || {}).filter(Boolean).length;

  ///* handlers
  const calcGridSize = () => {
    if (+tipoUsoTrueQuantity === 1) return gridSize;
    return gridSizeMdLg6;
  };

  return (
    <>
      {/* ------ Encuesta ------ */}
      <TabTextLabel text="Encuesta" pt="5px" pb="21px" />

      <EncuestaFieldsComponent
        encuesta={contract?.preagendamiento_data?.encuesta! || {}}
      />

      {/* ------ tipo de uso ------ */}
      <TabTextLabel text="Tipo de Uso" pt="45px" pb="21px" />
      <>
        {usos ? (
          <>
            {usos?.trabajo_estudio && (
              <SampleCheckboxNoForm
                label="Trabajo/Estudio"
                defaultValue={usos?.trabajo_estudio}
                disabled
                size={calcGridSize()}
                icon={<HomeWorkIcon />}
                overrideChecked
              />
            )}
            {usos?.entretenimiento && (
              <SampleCheckboxNoForm
                label="Entretenimiento"
                defaultValue={usos?.entretenimiento}
                icon={<YouTubeIcon />}
                disabled
                size={calcGridSize()}
                overrideChecked
              />
            )}

            {usos?.juegos && (
              <SampleCheckboxNoForm
                label="Juegos"
                defaultValue={usos?.juegos}
                icon={<VideogameAssetIcon />}
                disabled
                size={calcGridSize()}
                overrideChecked
              />
            )}
            {usos?.redes_sociales && (
              <SampleCheckboxNoForm
                label="Redes Sociales"
                defaultValue={usos?.redes_sociales}
                icon={<FacebookIcon />}
                disabled
                size={calcGridSize()}
                overrideChecked
              />
            )}
            {usos?.streaming && (
              <SampleCheckboxNoForm
                label="Streaming"
                defaultValue={usos?.streaming}
                icon={<LiveTvIcon />}
                disabled
                size={calcGridSize()}
                overrideChecked
              />
            )}
            {usos?.domotica && (
              <SampleCheckboxNoForm
                label="Domótica"
                defaultValue={usos?.domotica}
                icon={<RedditIcon />}
                size={calcGridSize()}
                disabled
                overrideChecked
              />
            )}
          </>
        ) : (
          <CustomAlertCard
            alertTitle="INFORMACIÓN"
            alertMessage='No se ha registrado información de "Usos" del servicio.'
          />
        )}
      </>
    </>
  );
};

export default ClienteFibraSurveyFormTab;
